export const movies = [
    {
        id: 0,
        name: 'Fight Club',
        desc: 'An insomniac office worker and a devil-may-care soap maker form an underground fight club that evolves into much more.',
        rating: 8.8,
        genre: 1,
    },
    {
        id: 1,
        name: 'The Godfather',
        desc: `An organized crime dynasty's aging patriarch transfers control of his clandestine empire to his reluctant son`,
        rating: 9.2,
        genre: 1,
    },
    {
        id: 2,
        name: 'The Shawshank Redemption',
        desc: `Two imprisoned men bond over a number of years, finding solace and eventual redemption through acts of common decency.`,
        rating: 9.3,
        genre: 1,
    },
    {
        id: 3,
        name: 'The Dark Knight',
        desc: `When the menace known as the Joker wreaks havoc and chaos on the people of Gotham, Batman must accept one of the greatest psychological and physical tests of his ability to fight injustice`,
        rating: 9.0,
        genre: 0,
    },
    {
        id: 4,
        name: 'The Lord of the Rings',
        desc: `A meek Hobbit from the Shire and eight companions set out on a journey to destroy the powerful One Ring and save Middle-earth from the Dark Lord Sauron.`,
        rating: 8.8,
        genre: 0,
    },
    {
        id: 5,
        name: 'Mission Impossible',
        desc: `Ethan Hunt and his IMF team, along with some familiar allies, race against time after a mission gone wrong.`,
        rating: 7.7,
        genre: 0,
    },
    {
        id: 6,
        name: 'Inception',
        desc: `A thief who steals corporate secrets through the use of dream-sharing technology is given the inverse task of planting an idea into the mind of a C.E.O.`,
        rating: 8.8,
        genre: 2,
    },
    {
        id: 7,
        name: 'Interstellar',
        desc: `A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival.`,
        rating: 8.6,
        genre: 2,
    },
    {
        id: 8,
        name: 'Edge of Tomorrow',
        desc: `A soldier fighting aliens gets to relive the same day over and over again, the day restarting every time he dies.`,
        rating: 7.9,
        genre: 2,
    },

]

export const genres = ['action', 'drama', 'sci-fi']
